export const setLocalStorage = ({ key, value, isStringify = true }) => {
  if (typeof value !== 'string' && isStringify) value = JSON.stringify(value)
  localStorage.setItem(key, value)
}
export const getLocalStorage = key => {
  const item = localStorage.getItem(key)
  return item
}
